module.exports = __webpack_public_path__ + "assets/630b67fd55e621e3918492fb5bb9319a.png";